"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkTaskFile = exports.isTaskFile = void 0;
const __1 = require("..");
function isTaskFile(object) {
    return checkTaskFile(object).fulfilled;
}
exports.isTaskFile = isTaskFile;
function checkTaskFile(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, __1.check)(object, (0, __1.hasString)("id"), (0, __1.hasString)("projectId"), (0, __1.hasString)("taskId"), (0, __1.hasNumber)("size").integer(), (0, __1.hasChoice)("type", ["IMAGE", "VIDEO", "AUDIO", "DOCUMENT", "FOLDER"]), (0, __1.hasNumber)("creationTimestamp").integer(), (0, __1.hasNumber)("lastModifiedTimestamp").integer(), (0, __1.hasString)("lastModifiedBy").optional(), (0, __1.hasString)("creatorId").optional(), (0, __1.hasObject)("meta", (0, __1.hasArray)("autoTags", (0, __1.isString)()).optional().nullable()).optional().nullable()).withOptions(options).explain();
}
exports.checkTaskFile = checkTaskFile;
//# sourceMappingURL=TaskFile.js.map